import React from "react";
import Reveal from "@/components/Reveal";
import QuoteWidget from "@/components/QuoteWidget";
import { WHATSAPP, openExternal } from "@/lib/contact";
import { MessageCircle, Upload, Zap, ShieldCheck } from "lucide-react";

const HIGHLIGHTS = [
  {
    icon: Upload,
    title: "Drop your STL",
    desc: "Drag-and-drop .STL / .OBJ / .3MF right into the viewer below.",
  },
  {
    icon: Zap,
    title: "See a live price",
    desc: "Pick material, colour and infill — the quote updates in seconds.",
  },
  {
    icon: ShieldCheck,
    title: "Pay + we deliver",
    desc: "Secure Razorpay checkout, same-day courier from Gunjur.",
  },
];

export default function InstantQuote() {
  return (
    <section
      id="quote"
      data-testid="instant-quote-section"
      className="relative py-24 sm:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 mb-14 items-end">
          <Reveal className="lg:col-span-6">
            <span className="label-overline">/ Instant quote</span>
            <h2 className="font-display text-4xl sm:text-5xl mt-6 leading-[1.05] font-semibold tracking-tight">
              Upload an STL,<br />see a price in seconds.
            </h2>
          </Reveal>
          <Reveal delay={120} className="lg:col-span-5 lg:col-start-8">
            <p className="text-zinc-400 leading-relaxed">
              Priced on our own printer profiles — not a per-gram formula —
              so the number you see is the number we print for. Final
              accuracy still depends on geometry, material and orientation.
            </p>
            <a
              href={WHATSAPP}
              target="_blank"
              rel="noreferrer"
              onClick={(e) => openExternal(e, WHATSAPP)}
              className="mt-4 inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 hover:text-[#FF5722] transition-colors"
              data-testid="quote-whatsapp-fallback"
            >
              <MessageCircle size={12} />
              Or WhatsApp your files instead
            </a>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-3 gap-4 mb-10">
          {HIGHLIGHTS.map((h, idx) => {
            const Icon = h.icon;
            return (
              <Reveal key={h.title} delay={idx * 90}>
                <div className="border border-white/10 bg-[#0F0F11] p-6 h-full rounded-2xl hover:border-[#FF5722]/40 transition-colors">
                  <div className="w-11 h-11 grid place-items-center border border-white/15 text-[#FF5722] mb-5">
                    <Icon size={18} />
                  </div>
                  <div className="label-overline mb-2">Step 0{idx + 1}</div>
                  <h3 className="font-display text-lg text-white mb-2">
                    {h.title}
                  </h3>
                  <p className="text-sm text-zinc-400 leading-relaxed">
                    {h.desc}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={200}>
          <QuoteWidget />
        </Reveal>
      </div>
    </section>
  );
}
